import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import Switch from "react-bootstrap-switch";
import {typeUdnService} from "../../../jwt/_services";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit, GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import * as Yup from "yup";
import {
    error, FORM,
    info,
    infoMsg,
    MAX_NAME,
    REQUIRED,
    saveMsg,
    success, updateMsg
} from "../../../components/i18n/i18n";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function TypeUdnForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [status, setStatus] = useState(false);
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            name: savedData?.name,
            code: savedData?.code,
            status: savedData?.status
        }
    });

    const statusChange = () => {
        setStatus(!status);
    }

    const onSubmit = (data, _) => {
        setLoading(true);

        let dataRequest = {
            name: data.name,
            code: data.code,
            status: status
        };

        if (!editMode) {
            //Save
            return typeUdnService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;

            if (JSON.stringify(savedData) === JSON.stringify(dataRequest))
                return showToastCustom(info, infoMsg);

            dataRequest = { ...dataRequest, id }

            return typeUdnService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setStatus(false);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Id</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="5">
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input type="name" name="name"
                                       placeholder="Ingrese nombre"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="name" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="5">
                            <FormGroup>
                                <Label>Código</Label>
                                    <Input type="name" name="code"
                                           placeholder="Ingrese codigo"
                                           innerRef={register}
                                           disabled={disableInputs}
                                           className={(errors.code ? ' is-invalid' : '')}
                                    />
                                    <ErrorMessage errors={errors} name="code" component="div"
                                                  className="invalid-feedback"/>

                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label><br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        innerRef={register}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={statusChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}